import { default as aboutu8Sb32ihwPMeta } from "/app/pages/about.vue?macro=true";
import { default as edituClm9gTK69Meta } from "/app/pages/admin/bikes/[id]/edit.vue?macro=true";
import { default as creategXITHI13dAMeta } from "/app/pages/admin/bikes/create.vue?macro=true";
import { default as indexZtnOrs7yaVMeta } from "/app/pages/admin/bikes/index.vue?macro=true";
import { default as index56CQtfNtrJMeta } from "/app/pages/admin/changelog/index.vue?macro=true";
import { default as indexS8SeIx1bhvMeta } from "/app/pages/admin/content/index.vue?macro=true";
import { default as contentbwqwkHSOoPMeta } from "/app/pages/admin/content.vue?macro=true";
import { default as indexi8nCATZISJMeta } from "/app/pages/admin/index.vue?macro=true";
import { default as editlg3iWoEYt6Meta } from "/app/pages/admin/locations/[id]/edit.vue?macro=true";
import { default as create2KC7XS1WrsMeta } from "/app/pages/admin/locations/create.vue?macro=true";
import { default as indexA0F0GD6w5HMeta } from "/app/pages/admin/locations/index.vue?macro=true";
import { default as edityDfj8earlWMeta } from "/app/pages/admin/locks/[id]/edit.vue?macro=true";
import { default as createe8qfxpO9zBMeta } from "/app/pages/admin/locks/create.vue?macro=true";
import { default as indexzqdMC7LLvjMeta } from "/app/pages/admin/locks/index.vue?macro=true";
import { default as reportsqKtdc7D3rpMeta } from "/app/pages/admin/reports.vue?macro=true";
import { default as indexv2efEDowJ4Meta } from "/app/pages/admin/reservations/index.vue?macro=true";
import { default as indexRS6tahnJHcMeta } from "/app/pages/admin/settings/index.vue?macro=true";
import { default as editU7QR1PC7h2Meta } from "/app/pages/admin/users/[id]/edit.vue?macro=true";
import { default as createdprUypI2dWMeta } from "/app/pages/admin/users/create.vue?macro=true";
import { default as indexYm9dzWmM2AMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as forgot_45passwordPFs5wuK5FuMeta } from "/app/pages/auth/forgot-password.vue?macro=true";
import { default as loginikXFF2hTKwMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as registerTCvAsPw3TEMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as reset_45password5ABZjlJW61Meta } from "/app/pages/auth/reset-password.vue?macro=true";
import { default as signupHJ1GDnyyMkMeta } from "/app/pages/auth/signup.vue?macro=true";
import { default as verify_45otpkESLVeCBuFMeta } from "/app/pages/auth/verify-otp.vue?macro=true";
import { default as contactV6oPJjs9RyMeta } from "/app/pages/contact.vue?macro=true";
import { default as how_45to_45lendiDw5e7XlZZMeta } from "/app/pages/how-to-lend.vue?macro=true";
import { default as how_45to_45use_45appmIiBijS83gMeta } from "/app/pages/how-to-use-app.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as install_45lockGq6KiVHsrLMeta } from "/app/pages/install-lock.vue?macro=true";
import { default as _91slug_93aMTVeVjCfjMeta } from "/app/pages/locations/[slug].vue?macro=true";
import { default as indexILfcf96YXkMeta } from "/app/pages/locations/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as indexJAGtIFrVmXMeta } from "/app/pages/owner/index.vue?macro=true";
import { default as indexcYV5fsdRinMeta } from "/app/pages/owner/reservations/index.vue?macro=true";
import { default as pricingpTmAIboEh0Meta } from "/app/pages/pricing.vue?macro=true";
import { default as privacyg3gwBRGXatMeta } from "/app/pages/privacy.vue?macro=true";
import { default as termsy18ZESLqu6Meta } from "/app/pages/terms.vue?macro=true";
import { default as troubleshooting3yrEipnYLcMeta } from "/app/pages/troubleshooting.vue?macro=true";
import { default as dashboardXHMBgXYAUgMeta } from "/app/pages/user/dashboard.vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ja",
    path: "/ja/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "admin-bikes-id-edit___en",
    path: "/admin/bikes/:id()/edit",
    meta: edituClm9gTK69Meta || {},
    component: () => import("/app/pages/admin/bikes/[id]/edit.vue")
  },
  {
    name: "admin-bikes-id-edit___ja",
    path: "/ja/admin/bikes/:id()/edit",
    meta: edituClm9gTK69Meta || {},
    component: () => import("/app/pages/admin/bikes/[id]/edit.vue")
  },
  {
    name: "admin-bikes-create___en",
    path: "/admin/bikes/create",
    meta: creategXITHI13dAMeta || {},
    component: () => import("/app/pages/admin/bikes/create.vue")
  },
  {
    name: "admin-bikes-create___ja",
    path: "/ja/admin/bikes/create",
    meta: creategXITHI13dAMeta || {},
    component: () => import("/app/pages/admin/bikes/create.vue")
  },
  {
    name: "admin-bikes___en",
    path: "/admin/bikes",
    meta: indexZtnOrs7yaVMeta || {},
    component: () => import("/app/pages/admin/bikes/index.vue")
  },
  {
    name: "admin-bikes___ja",
    path: "/ja/admin/bikes",
    meta: indexZtnOrs7yaVMeta || {},
    component: () => import("/app/pages/admin/bikes/index.vue")
  },
  {
    name: "admin-changelog___en",
    path: "/admin/changelog",
    meta: index56CQtfNtrJMeta || {},
    component: () => import("/app/pages/admin/changelog/index.vue")
  },
  {
    name: "admin-changelog___ja",
    path: "/ja/admin/changelog",
    meta: index56CQtfNtrJMeta || {},
    component: () => import("/app/pages/admin/changelog/index.vue")
  },
  {
    name: contentbwqwkHSOoPMeta?.name,
    path: "/admin/content",
    component: () => import("/app/pages/admin/content.vue"),
    children: [
  {
    name: "admin-content___en",
    path: "",
    meta: indexS8SeIx1bhvMeta || {},
    component: () => import("/app/pages/admin/content/index.vue")
  }
]
  },
  {
    name: contentbwqwkHSOoPMeta?.name,
    path: "/ja/admin/content",
    component: () => import("/app/pages/admin/content.vue"),
    children: [
  {
    name: "admin-content___ja",
    path: "",
    meta: indexS8SeIx1bhvMeta || {},
    component: () => import("/app/pages/admin/content/index.vue")
  }
]
  },
  {
    name: "admin___en",
    path: "/admin",
    meta: indexi8nCATZISJMeta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin___ja",
    path: "/ja/admin",
    meta: indexi8nCATZISJMeta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-locations-id-edit___en",
    path: "/admin/locations/:id()/edit",
    meta: editlg3iWoEYt6Meta || {},
    component: () => import("/app/pages/admin/locations/[id]/edit.vue")
  },
  {
    name: "admin-locations-id-edit___ja",
    path: "/ja/admin/locations/:id()/edit",
    meta: editlg3iWoEYt6Meta || {},
    component: () => import("/app/pages/admin/locations/[id]/edit.vue")
  },
  {
    name: "admin-locations-create___en",
    path: "/admin/locations/create",
    meta: create2KC7XS1WrsMeta || {},
    component: () => import("/app/pages/admin/locations/create.vue")
  },
  {
    name: "admin-locations-create___ja",
    path: "/ja/admin/locations/create",
    meta: create2KC7XS1WrsMeta || {},
    component: () => import("/app/pages/admin/locations/create.vue")
  },
  {
    name: "admin-locations___en",
    path: "/admin/locations",
    meta: indexA0F0GD6w5HMeta || {},
    component: () => import("/app/pages/admin/locations/index.vue")
  },
  {
    name: "admin-locations___ja",
    path: "/ja/admin/locations",
    meta: indexA0F0GD6w5HMeta || {},
    component: () => import("/app/pages/admin/locations/index.vue")
  },
  {
    name: "admin-locks-id-edit___en",
    path: "/admin/locks/:id()/edit",
    meta: edityDfj8earlWMeta || {},
    component: () => import("/app/pages/admin/locks/[id]/edit.vue")
  },
  {
    name: "admin-locks-id-edit___ja",
    path: "/ja/admin/locks/:id()/edit",
    meta: edityDfj8earlWMeta || {},
    component: () => import("/app/pages/admin/locks/[id]/edit.vue")
  },
  {
    name: "admin-locks-create___en",
    path: "/admin/locks/create",
    meta: createe8qfxpO9zBMeta || {},
    component: () => import("/app/pages/admin/locks/create.vue")
  },
  {
    name: "admin-locks-create___ja",
    path: "/ja/admin/locks/create",
    meta: createe8qfxpO9zBMeta || {},
    component: () => import("/app/pages/admin/locks/create.vue")
  },
  {
    name: "admin-locks___en",
    path: "/admin/locks",
    meta: indexzqdMC7LLvjMeta || {},
    component: () => import("/app/pages/admin/locks/index.vue")
  },
  {
    name: "admin-locks___ja",
    path: "/ja/admin/locks",
    meta: indexzqdMC7LLvjMeta || {},
    component: () => import("/app/pages/admin/locks/index.vue")
  },
  {
    name: "admin-reports___en",
    path: "/admin/reports",
    meta: reportsqKtdc7D3rpMeta || {},
    component: () => import("/app/pages/admin/reports.vue")
  },
  {
    name: "admin-reports___ja",
    path: "/ja/admin/reports",
    meta: reportsqKtdc7D3rpMeta || {},
    component: () => import("/app/pages/admin/reports.vue")
  },
  {
    name: "admin-reservations___en",
    path: "/admin/reservations",
    meta: indexv2efEDowJ4Meta || {},
    component: () => import("/app/pages/admin/reservations/index.vue")
  },
  {
    name: "admin-reservations___ja",
    path: "/ja/admin/reservations",
    meta: indexv2efEDowJ4Meta || {},
    component: () => import("/app/pages/admin/reservations/index.vue")
  },
  {
    name: "admin-settings___en",
    path: "/admin/settings",
    meta: indexRS6tahnJHcMeta || {},
    component: () => import("/app/pages/admin/settings/index.vue")
  },
  {
    name: "admin-settings___ja",
    path: "/ja/admin/settings",
    meta: indexRS6tahnJHcMeta || {},
    component: () => import("/app/pages/admin/settings/index.vue")
  },
  {
    name: "admin-users-id-edit___en",
    path: "/admin/users/:id()/edit",
    meta: editU7QR1PC7h2Meta || {},
    component: () => import("/app/pages/admin/users/[id]/edit.vue")
  },
  {
    name: "admin-users-id-edit___ja",
    path: "/ja/admin/users/:id()/edit",
    meta: editU7QR1PC7h2Meta || {},
    component: () => import("/app/pages/admin/users/[id]/edit.vue")
  },
  {
    name: "admin-users-create___en",
    path: "/admin/users/create",
    meta: createdprUypI2dWMeta || {},
    component: () => import("/app/pages/admin/users/create.vue")
  },
  {
    name: "admin-users-create___ja",
    path: "/ja/admin/users/create",
    meta: createdprUypI2dWMeta || {},
    component: () => import("/app/pages/admin/users/create.vue")
  },
  {
    name: "admin-users___en",
    path: "/admin/users",
    meta: indexYm9dzWmM2AMeta || {},
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "admin-users___ja",
    path: "/ja/admin/users",
    meta: indexYm9dzWmM2AMeta || {},
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "auth-forgot-password___en",
    path: "/auth/forgot-password",
    component: () => import("/app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___ja",
    path: "/ja/auth/forgot-password",
    component: () => import("/app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login___en",
    path: "/auth/login",
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___ja",
    path: "/ja/auth/login",
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-register___en",
    path: "/auth/register",
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___ja",
    path: "/ja/auth/register",
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___ja",
    path: "/ja/auth/reset-password",
    component: () => import("/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-signup___en",
    path: "/auth/signup",
    component: () => import("/app/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___ja",
    path: "/ja/auth/signup",
    component: () => import("/app/pages/auth/signup.vue")
  },
  {
    name: "auth-verify-otp___en",
    path: "/auth/verify-otp",
    component: () => import("/app/pages/auth/verify-otp.vue")
  },
  {
    name: "auth-verify-otp___ja",
    path: "/ja/auth/verify-otp",
    component: () => import("/app/pages/auth/verify-otp.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ja",
    path: "/ja/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "how-to-lend___en",
    path: "/how-to-lend",
    component: () => import("/app/pages/how-to-lend.vue")
  },
  {
    name: "how-to-lend___ja",
    path: "/ja/how-to-lend",
    component: () => import("/app/pages/how-to-lend.vue")
  },
  {
    name: "how-to-use-app___en",
    path: "/how-to-use-app",
    component: () => import("/app/pages/how-to-use-app.vue")
  },
  {
    name: "how-to-use-app___ja",
    path: "/ja/how-to-use-app",
    component: () => import("/app/pages/how-to-use-app.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "install-lock___en",
    path: "/install-lock",
    component: () => import("/app/pages/install-lock.vue")
  },
  {
    name: "install-lock___ja",
    path: "/ja/install-lock",
    component: () => import("/app/pages/install-lock.vue")
  },
  {
    name: "locations-slug___en",
    path: "/locations/:slug()",
    component: () => import("/app/pages/locations/[slug].vue")
  },
  {
    name: "locations-slug___ja",
    path: "/ja/locations/:slug()",
    component: () => import("/app/pages/locations/[slug].vue")
  },
  {
    name: "locations___en",
    path: "/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___ja",
    path: "/ja/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "owner___en",
    path: "/owner",
    meta: indexJAGtIFrVmXMeta || {},
    component: () => import("/app/pages/owner/index.vue")
  },
  {
    name: "owner___ja",
    path: "/ja/owner",
    meta: indexJAGtIFrVmXMeta || {},
    component: () => import("/app/pages/owner/index.vue")
  },
  {
    name: "owner-reservations___en",
    path: "/owner/reservations",
    meta: indexcYV5fsdRinMeta || {},
    component: () => import("/app/pages/owner/reservations/index.vue")
  },
  {
    name: "owner-reservations___ja",
    path: "/ja/owner/reservations",
    meta: indexcYV5fsdRinMeta || {},
    component: () => import("/app/pages/owner/reservations/index.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___ja",
    path: "/ja/pricing",
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___ja",
    path: "/ja/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "terms___ja",
    path: "/ja/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "troubleshooting___en",
    path: "/troubleshooting",
    component: () => import("/app/pages/troubleshooting.vue")
  },
  {
    name: "troubleshooting___ja",
    path: "/ja/troubleshooting",
    component: () => import("/app/pages/troubleshooting.vue")
  },
  {
    name: "user-dashboard___en",
    path: "/user/dashboard",
    component: () => import("/app/pages/user/dashboard.vue")
  },
  {
    name: "user-dashboard___ja",
    path: "/ja/user/dashboard",
    component: () => import("/app/pages/user/dashboard.vue")
  }
]